import React from 'react';

const Header: React.FC = () => {
    return (
        <header className="w-full max-w-7xl mx-auto py-6 flex justify-between items-center z-10">
            <div className="flex items-center space-x-2">
                <h1 className="text-3xl font-bold text-blue-400">锐奇物联</h1>
                <span className="text-lg text-gray-400">RichinLogic</span>
            </div>
            <nav>
                <ul className="flex space-x-6">
                    <li><a href="#home" className="text-gray-300 hover:text-blue-300 transition-colors duration-200">首页</a></li>
                    <li><a href="#about" className="text-gray-300 hover:text-blue-300 transition-colors duration-200">关于我们</a></li>
                    <li><a href="#solutions" className="text-gray-300 hover:text-blue-300 transition-colors duration-200">解决方案</a></li>
                    <li><a href="#cases" className="text-gray-300 hover:text-blue-300 transition-colors duration-200">案例展示</a></li>
                    <li><a href="#contact" className="text-gray-300 hover:text-blue-300 transition-colors duration-200">联系我们</a></li>
                </ul>
            </nav>
        </header>
    );
};

export default Header; 